<template>
  <div
    id="m_quick_sidebar"
    class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light m-quick-sidebar--on"
  >
    <div class="m-quick-sidebar__content">
      <span class="m-quick-sidebar__close mt-2" @click="closeThis()"
        ><i class="fal fa-times-circle fa-lg"></i
      ></span>
      <div class="tab-content">
        <div class="tab-pane active" role="tabpanel">
          <InvoiceLooseSave />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InvoiceLooseSave from '@/components/invoices/InvoiceLooseSave';

export default {
  name: 'InvoiceLooseModal',
  components: { InvoiceLooseSave },
  methods: {
    closeThis() {
      this.$emit('updateList');
      this.$store.state.showInvoiceLoose = null;
    },
  },
  computed: {
    invoiceLooseId() {
      return this.$store.state.showInvoiceLoose;
    },
  },
};
</script>
